import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Divider from 'granite-admin/core/components/Divider';
import { StyledSpan } from 'granite-admin/core/components/Animations/SkeletonAnimation';
const LabelBox = styled(StyledSpan)`
  height: 15px;
  width: calc(100% - 5px);
`;
const IconBox = styled(StyledSpan)`
  border-radius: 50%;
  width: 30px;
  height: 25px;
`;
const SidebarSkeletonLoader = ({
  isCollapsed
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    flex: true,
    overflow: {
      vertical: 'auto',
      horizontal: 'hidden'
    },
    gap: "small",
    pad: "small"
  }, [...Array(4).keys()].map((i, ind) => /*#__PURE__*/React.createElement(Box, {
    key: ind + 'sidebar-box',
    gap: "small",
    pad: "small",
    flex: {
      shrink: 0
    }
  }, !isCollapsed && /*#__PURE__*/React.createElement(LabelBox, null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    gap: "small"
  }, [...Array(2).keys()].map((j, index) => /*#__PURE__*/React.createElement(Box, {
    key: index + 'menu-item',
    direction: "row",
    gap: "medium",
    align: "center",
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(IconBox, null), !isCollapsed && /*#__PURE__*/React.createElement(LabelBox, null)))))));
};
SidebarSkeletonLoader.propTypes = {
  isCollapsed: PropTypes.bool
};
export default SidebarSkeletonLoader;